import { useState } from "react";
import { Link } from "react-router-dom";
import { SECTOR_LIST } from "@/data/sectors";
import PackFlickthrough from "@/components/PackFlickthrough";
import { Button } from "@/components/ui/button";
import { ArrowRight, FileText } from "lucide-react";

const POINTS = ["Every policy written to your regulator's current framework", "Word + PDF, ready to brand — and editable in-app", "Staff sign-off tracking and a full audit trail for inspectors"];

export default function PackShowcase() {
  const [active, setActive] = useState(SECTOR_LIST[0]);
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="pack-showcase">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <span className="overline text-accent">Policy packs</span>
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mt-1 mb-3">Flick through a real policy pack</h2>
          <p className="text-muted-foreground mb-6">Pick your sector to see the actual pages inside — no mock-ups, these are the documents you download.</p>
          <div className="flex flex-wrap gap-2 mb-6" role="tablist">
            {SECTOR_LIST.map((s) => (
              <button key={s.id} role="tab" aria-selected={active.id === s.id} onClick={() => setActive(s)} data-testid={`pack-showcase-tab-${s.id}`}
                className={`px-3.5 py-1.5 rounded-full text-sm font-medium border transition-colors ${active.id === s.id ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border hover:border-primary/50"}`}>
                {s.navLabel} · {s.navSub}
              </button>
            ))}
          </div>
          <ul className="space-y-2 mb-6">
            {POINTS.map((p) => <li key={p} className="flex items-start gap-2 text-sm text-muted-foreground"><FileText className="w-4 h-4 text-accent mt-0.5 shrink-0" /> {p}</li>)}
          </ul>
          <Button asChild data-testid="pack-showcase-cta"><Link to={`${active.path}#sector-products`}>See {active.navLabel} packs &amp; prices <ArrowRight className="w-4 h-4 ml-1.5" /></Link></Button>
        </div>
        <div className="lg:col-span-7"><PackFlickthrough sectorId={active.id} share /></div>
      </div>
    </section>
  );
}
